import './utopia-vouchers.scss';
import { Enum, PaginationList } from '../../../../core/domain';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { getIconPath } from '../../../../core/utils/getIconPath';
import { Divider, Dropdown, Menu, message, Tag } from 'antd';
import { digitSperator, faNumToEnNum } from '../../../../core/utils/decimalExtentions';
import moment from 'jalali-moment';
import { Badge } from '../../../../components';
import { DeleteOutlined, EditOutlined, InfoCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { ReactComponent as CalendarIcon } from 'assets/icons/dash-line-icons/calendar.svg';
import { getOrderSides } from '../../../../core/repositories/orders';
import { getPageNum } from '../../../../core/utils/paggingHelper';
import { Card } from '../../../../components/card/card';
import { Input, inputType } from '../../../../components/input/input';
import { Button, buttonType } from '../../../../components/button/button';
import { Table } from '../../../../components/table/table';
import { Dropdown as CustomDropdown } from 'components/dropdown/dropdown';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import * as React from 'react';
import { Page } from 'components/page/page';
import { BadgeType } from 'components/badge/badge';
import { useNavigate } from 'react-router-dom';
import { getAllBalancerTransactions, removeBalancerTransaction } from 'core/repositories/balancer-transaction';
import { UtopiaVoucher } from 'core/domain/utopia-vouchers/utopia-vouchers';
import { getAllUtopiaVouchers } from 'core/repositories/utopia-vouchers';
import { getUtopiaFilters } from 'core/repositories/track-voucher';
import { jFormat } from 'core/utils/jFormat';

const initialFilters = {
    keyword: '',
    filter: {
        id: -1,
        title: 'همه فیلتر ها',
    },
};

export const UtopiaVouchers = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [utopiaVouchers, setUtopiaVouchers] = useState<PaginationList<UtopiaVoucher>>();

    //Enums
    const [utopiaFilters, setUtopiaFilters] = useState<Enum[]>([initialFilters.filter]);

    const [pageSize, setPageSize] = useState<number>(10);

    const [query, setQuery] = useState<string>('');

    const [filterValues, setFilterValues] = useState<{
        keyword?: string;
        from?: string;
        to?: string;
        filter: Enum;
    }>({
        filter: initialFilters.filter,
    });

    const navigate = useNavigate();

    const startDateRef = useRef();
    const endDateRef = useRef();

    const columns: any[] = [
        {
            name: 'مقدار',
            id: 'amount',
            selector: (row: UtopiaVoucher) => row.amount,
            cell: (row: UtopiaVoucher) => digitSperator(row.amount),
            width: '20%',
        },
        {
            name: 'کد نتیجه',
            id: 'resultCode',
            selector: (row: UtopiaVoucher) => row.resultCode,
            width: '15%',
        },
        {
            name: 'نوع',
            id: 'type',
            selector: (row: UtopiaVoucher) => row.type,
            cell: (row: UtopiaVoucher) => row.type,
            width: '20%',
        },
        {
            name: 'وضعیت',
            id: 'state',
            selector: (row: UtopiaVoucher) => row.state,
            cell: (row: UtopiaVoucher) => row.state,
            width: '20%',
        },
        {
            name: 'تاریخ ایجاد',
            id: 'created',
            selector: (row: UtopiaVoucher) => row.created,
            cell: (row: UtopiaVoucher) => (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <span className="time">{moment.utc(row.created).local().format('HH:mm')}</span>
                    <span>{' - '}</span>
                    <span className="day">{moment.utc(row.created).locale('fa').local().format('jYYYY/MM/DD')}</span>
                </div>
            ),
            width: '25%',
        },
    ];

    const handleEnums = async () => {
        await getUtopiaFilters(setLoading, setUtopiaFilters);
    };

    const fetchData = async () => {
        try {
            getAllUtopiaVouchers(setLoading, setUtopiaVouchers, 1, pageSize, query);
        } catch (e) {
            message.error('خطا در بارگیری اطلاعات');
        } finally {
            setLoading(false);
        }
    };

    const filterHandle = () => {
        var q = '';

        if (filterValues.keyword) q += `${q.includes('?') ? '&' : '?'}keyword=${filterValues.keyword}`;

        if (filterValues.filter.id !== -1) q += `${q.includes('?') ? '&' : '?'}filter=${filterValues.filter.id}`;
        if (filterValues.from !== '')
            q += `${q.includes('?') ? '&' : '?'}from=${jFormat(filterValues.from)}`;
        if (filterValues.to !== '')
            q += `${q.includes('?') ? '&' : '?'}to=${jFormat(filterValues.to)}`;
        setQuery(q);
        getAllUtopiaVouchers(setLoading, setUtopiaVouchers, 1, pageSize, q);
    };

    useEffect(() => {
        handleEnums();

    }, []);

    return (
        <Page className="pmx-utopia-vouchers" title="ووچر های یوتوپیا">
            <Card title="گزارشات ووچر های یوتوپیا" blur={loading}>
                <div className="filter-row">
                    <div className="fields">

                        <Input
                            value={filterValues.keyword}
                            className="search"
                            placeholder="عبارت جهت جستجو را وارد کنید"
                            name="search"
                            onPressEnter={filterHandle}
                            onChange={(e) => setFilterValues({ ...filterValues, keyword: e.target.value })}
                        />

                        <CustomDropdown
                            items={utopiaFilters}
                            onChangeHandle={(value) =>
                                setFilterValues({
                                    ...filterValues,
                                    filter: utopiaFilters?.find((l) => l.id === value),
                                })
                            }
                            selectedOption={filterValues.filter}
                            defaultSelected={filterValues.filter}
                        />

                        <DatePicker
                            className="date-picker"
                            value={filterValues.from}
                            calendar={persian}
                            ref={startDateRef}
                            locale={persian_fa}
                            render={
                                <div>
                                    <Input
                                        value={filterValues.from}
                                        icon={<CalendarIcon />}
                                        placeholder="از تاریخ"
                                    />
                                </div>
                            }
                            onChange={(e) => {
                                setFilterValues({
                                    ...filterValues,
                                    from: e.format(),
                                });
                            }}
                        />
                        <DatePicker
                            className="date-picker"
                            value={filterValues.to}
                            calendar={persian}
                            ref={endDateRef}
                            locale={persian_fa}
                            render={
                                <div>
                                    <Input
                                        value={filterValues.to}
                                        icon={<CalendarIcon />}
                                        placeholder="تا تاریخ"
                                    />
                                </div>
                            }
                            onChange={(e) => {
                                setFilterValues({
                                    ...filterValues,
                                    to: e.format(),
                                });
                            }}
                        />
                    </div>

                    <Divider type="vertical" />
                    <div className="buttons">
                        <Button
                            loading={loading}
                            disabled={loading}
                            onClick={() => filterHandle()}
                            text="اعمال فیلتر"
                            type={buttonType.success}
                        />
                        <Button
                            type={buttonType.error}
                            text={'حذف فیلتر'}
                            onClick={() => {
                                setFilterValues({
                                    from: '',
                                    to: '',
                                    filter: initialFilters.filter,
                                    keyword: initialFilters.keyword,
                                });
                                getAllUtopiaVouchers(setLoading, setUtopiaVouchers, getPageNum(), pageSize, '');
                            }}
                        />
                    </div>
                </div>
                {utopiaVouchers && (
                    <Table
                        filters={query}
                        setloader={setLoading}
                        setdata={setUtopiaVouchers}
                        getdata={getAllUtopiaVouchers}
                        pagination={utopiaVouchers.pagination}
                        data={utopiaVouchers.items}
                        column={columns}
                        setPageSize={setPageSize}
                        pageSize={utopiaVouchers?.pagination?.pageSize}
                        className={'utopia-vouchers-table'}
                    />
                )}
            </Card>
        </Page>
    );
};
